
<template>
  <div id="knowledge-base-page">
    <div class="vx-row rounded-lg mb-base">
      <vx-card title="Key Performance Indicator">
        <vs-table :data="kpilist" class="table-dark-inverted" style="width: 100%" search>
          <template slot="thead">
            <vs-th>#</vs-th>
            <vs-th>Category</vs-th>
            <vs-th>Report Name</vs-th>
            <vs-th>Online Date</vs-th>
            <vs-th> </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextrr" v-for="(tr, indextrr) in data">
              <vs-td>
                <span> {{ indextrr + 1 }} </span>
              </vs-td>
              <vs-td>
                <span> {{ tr.category }} </span>
              </vs-td>
              <vs-td>
                <span> {{ tr.name }} </span>
              </vs-td>
              <vs-td>
                <span> <vs-chip v-if="tr.date === 'offline'" class="ag-grid-cell-chips" color="danger">{{ tr.date }} </vs-chip>
                  <vs-chip v-else class="ag-grid-cell-chips" color="success">{{ tr.date }} </vs-chip></span>
              </vs-td>
              <vs-td>
                <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                  @click="ViewRecord(tr.date, tr.url)" />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>

    <!-- Historical analysis of the quotation dashboard volume (m³), year over year. -->
    <div class="vx-row rounded-lg mb-base">
      <quotation-backlog-analysis />
    </div>
  </div>
</template>

<script>
import moduleBankList from "@/store/bank/moduleDataList.js";
import { Row } from "jspdf-autotable";
import QuotationBacklogAnalysis from "@/views/analytics/QuotationBacklogAnalysis.vue";

export default {
  data() {
    return {
      kpilist: {}
    }
  },
  computed: {
  },
  methods: {
    ViewRecord(date, url) {
      if (date === 'offline') {
        this.$vs.notify({
          title: "Offline",
          text: "The report is currently offline",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "bottom-right",
          time: 8000,
        });
      }
      else {
        window.location.href = url;
      }
    },
    handleButtonClick(event, path) {
      if (event.ctrlKey || event.metaKey) {
        window.open(path, '_blank');
      } else {
        this.$router.push(path);
      }
    },
    loadKPI() {
      this.$store
        .dispatch("BankList/loadKPI")
        .then(res => {
          this.kpilist = res.data
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
  created() {
    if (!(localStorage.getItem("login-roles") || "").toLowerCase().includes("admin")) {
      this.$vs.notify({
        title: "Denied",
        text: "Redirection",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/" });
    }
    if (!moduleBankList.isRegistered) {
      this.$store.registerModule("BankList", moduleBankList);
      moduleBankList.isRegistered = true;
    }
    try {
      try { this.loadKPI() } catch (error) { console.error("Error loading connected bank and account:", error) }
    } catch (error) {
      console.error("Error in component created hook:", error);
    }
  },
  components: { QuotationBacklogAnalysis }
}
</script>

<style lang="scss">
.knowledge-base-jumbotron-content {
  background-image: url('../../assets/images/pages/knowledge-base-cover.jpg');
  background-size: cover;
  height: 250px;
}

.institution {
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  border: 1px solid #eaeaea;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
  transition: background-color 0.3s ease;
}

.institution:hover {
  background-color: #e6f7ff;
}

.institution img {
  margin-right: 15px;
  border-radius: 5px;
}

.institution-info {
  flex-grow: 1;
}
</style>
